import { memo } from "react";
import LoadingButton, { type LoadingButtonProps } from "@mui/lab/LoadingButton";
import { useParams } from "infrastructure/router";
import { Filters } from "consts/onboarding";
import useSendApplicationDecision from "features/onboarding/useSendApplicationDecision";

const SendApplicationDecision = (props: LoadingButtonProps) => {
    const params = useParams();

    const {
        isLoading,
        sendApplicationDecision
    } = useSendApplicationDecision();

    const onClick = () => sendApplicationDecision({
        userId: String(params[Filters.pki])
    });

    return (
        <LoadingButton
            {...props}
            fullWidth
            variant='contained'
            color='primary'
            size='large'
            loading={isLoading}
            onClick={onClick}
        >
            Send Decision
        </LoadingButton>
    );
};

export default memo(SendApplicationDecision);
